/* src/js/apptCal.js */

jQuery( document ).ready(function( $ ) {


    //$('.apptscheduler td:empty').html( "Was empty!" );


    $(".apptscheduler td").filter(function () {
        return $.trim($(this).text()) === '';
    }).text( "\u2014" );






});



